// eslint-disable-next-line
import React from 'react';
import { IOStatusBadgeOpen } from './IOStatusBadgeOpen';
import { IOStatus } from '../../lib/dry-contact-helpers';
import { IOStatusBadgeClosed } from './IOStatusBadgeClosed';
import { IOStatusBadgeNotConfigured } from './IOStatusBadgeNotConfigured';

type IOStatusBadgeProps = { status: string; isUpperCase?: boolean; };

export const IOStatusBadge: React.FC<React.PropsWithChildren<IOStatusBadgeProps>> = ({ status, isUpperCase = true }) => {
    return <>
        {status === IOStatus.Open && <IOStatusBadgeOpen isUpperCase={isUpperCase} />}
        {status === IOStatus.Closed && <IOStatusBadgeClosed isUpperCase={isUpperCase} />}
        {status === IOStatus.NotConfigured && <IOStatusBadgeNotConfigured isUpperCase={isUpperCase} />}
    </>
};
